import React from "react";

const Loading = () => (
    <div className="loading-animation">Loading...</div>
);

export default Loading;
